import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class ScreenSizeService {
    screenHeight: number;
    screenWidth: number;

    constructor() {
        this.screenSize();
        window.addEventListener("resize", () => {
            this.screenSize();
        });
    }

    screenSize() {
        this.screenHeight = window.innerHeight;
        this.screenWidth = window.innerWidth;
    }

    getScreenWidth() {
        return this.screenWidth;
    }

    getScreenHeight() {
        return this.screenHeight;
    }
}
